import { render, staticRenderFns } from "./KrokResultStudentView.vue?vue&type=template&id=ed4ab37c"
import script from "./KrokResultStudentView.vue?vue&type=script&lang=js"
export * from "./KrokResultStudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports